import Button from "Components/Button";
import MainLayout from "Layouts/Main";
import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "./style.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPreviewDetail, getSpareParts, updateSparePartsLog } from "../../../../Redux/Slices/Accessor/accessorSlice";
import html2pdf from "html2pdf.js";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import firstPage from "../../../../Assets/Images/pdfFirstPage.jpg";
import FooterColorLineData from "Services/data/footerColorLineData";
import sampleProfile from "../../../../Assets/Images/avator.png";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import PDFIcom from "../../../../Assets/Images/pdfImg.png";
import DocIcon from "../../../../Assets/Images/doc.png";
import XlsIcon from "../../../../Assets/Images/xlsx.png";
import { notifySuccess } from "Services/Utils/toastNotification";
import ImageModal from "Components/ImageModal";
import { getPdfData, getReportDetailspdfData, multiUpload, updatePdfURL } from "../../../../Redux/Slices/User/userSlice";
import { ReportDownload } from "Components/ReportDownload";
import Loader from "Components/Loader";
import { addApproveReject } from "../../../../Redux/Slices/Approver/approverSlice";
import Modal from "Components/Modal";
import InputBox from "Components/InputBox";

const ApprovalPreview = () => {
    const [openAccordion, setOpenAccordion] = useState([0]);
    const [openAccordionSpare, setOpenAccordionSpare] = useState(null);
    const [previewData, setPreviewData] = useState([]);
    const [sparePartsLogData, setSparePartsLogData] = useState({});
    const [openAccordionUploadedSpare, setOpenAccordionUploadedSpare] = useState(null);
    const [uploadedSpareParts, setUploadedSpareParts] = useState([]);
    const location = useLocation();
    const assessment_id = location?.state?.assessment_id || null;
    const approvalStatus = location?.state?.approval_status || null;
    const assessor_id = location?.state?.assessor_id;
    const payload = location?.state?.payload || null;
    const reviewed = location?.state?.reviewed || null;
    const contentRef = useRef();
    const isloading = useSelector((state) => state.accessor.isLoading);
    const [isLoading, setIsloading] = useState(false);
    const assessmentID = location?.state?.assessment_id || null;
    const [showall, setshowAll] = useState(false);
    const [isShowDownload, setIsShowDownload] = useState(false)
    const [pdfReport, setPdfReport] = useState(null)
    const [scores, setScores] = useState(null)
    const [isLoader, setIsLoader] = useState(false)
    const [rejectionReason, setRejectionReason] = useState("");
    const [errorReasonMessage, setErrorReasonMessage] = useState("");
    const [rejectModal, setRejectModal] = useState(false);
    const downloadRef = useRef()
    const dispatch = useDispatch();
    const { AssesmentId } = useParams()
    const navigate = useNavigate();
    const downloadButton = {
        width: "auto",
        height: "48px",
        backgroundColor: "#1F2155",
        border: "1.5px solid #1F2155",
        textAlign: "center",
    };

    const noteLabel = {
        color: "#2E2E2E",
        fontSize: "16px",
        fontWeight: "600",
    };

    const downloadTitle = {
        fontSize: "20px",
        fontWeight: "600",
    };

    const rejectTitle = {
        fontSize: "16px",
        fontWeight: "600",
        color: "#F04343",
    };

    const rejectButton = {
        background: "transparent",
        border: "1px solid #F76363",
        height: "44px",
        outline: "none",
    };

    const approveButton = {
        background: "#03B544",
        border: "1px solid  #03B544",
        height: "44px",
        outline: "none",
    };

    const approveTitle = {
        fontSize: "16px",
        fontWeight: "600",
        color: "white",
    };

    const toggleAccordion = (index) => {
        if (openAccordion?.includes(index)) {
            setOpenAccordion(openAccordion.filter((item) => item !== index));
        } else {
            setOpenAccordion([...openAccordion, index]);
        }
    };

    const toggleSpareAccordion = (index) => {
        setOpenAccordionSpare(openAccordionSpare === index ? null : index);
    };

    useEffect(() => {
        getPreviewDetails();
        getSpareparts();
    }, []);

    const getSpareparts = () => {
        dispatch(getSpareParts({
            assessment_id: AssesmentId,
            callBack: getSparePartsData,
        }));
    }

    const getSparePartsData = (data) => {
        setUploadedSpareParts(data); // store API data in state
        console.log(data, "spare parts data");
    }

    const getPreviewDetails = () => {
        dispatch(
            getPreviewDetail({
                assessment_id: assessment_id,
                callBack: getPreviewDetailsData,
            })
        );
    };

    const getPreviewDetailsData = (data) => {
        setPreviewData(data?.data);
        setSparePartsLogData(data?.sparePartLogData);

    };

    const handleApprove = () => {
        if (isLoading) {
            return;
        }
        setIsloading(true);
        const body = {
            approval_status: 2,
            assessor_id: assessor_id,
        };
        dispatch(
            addApproveReject({
                assessment_id: assessment_id,
                body: body,
                callBack: onApproveSuccess,
            })
        );

    };

    const onApproveSuccess = () => {
        notifySuccess("Assessment Approved Successfully");
        navigate("/");
        setIsloading(false);
    };

    const onReject = () => {
        setRejectModal(true);
    };

    const handleDownloadPDF = async (backlogId) => {
        setIsShowDownload(true);
        setIsLoader(true);

        try {
            dispatch(
                getReportDetailspdfData({
                    assessmentId: backlogId,
                    callBack: (data) => {
                        const existingUrl = data?.data?.data?.url || data?.data?.data;

                        if (
                            existingUrl &&
                            typeof existingUrl === "string" &&
                            existingUrl.startsWith("http")
                        ) {
                            window.open(existingUrl, "_blank", "noreferrer");
                            setIsShowDownload(false);
                            setIsLoader(false);
                        }

                        else {
                            dispatch(
                                getPdfData({
                                    reportId: backlogId,
                                    callBack: (pdfData) => {
                                        if (pdfData) {
                                            getScores(pdfData);
                                            setPdfReport({
                                                ...pdfData,
                                                currentBacklogId: backlogId,
                                            });
                                        } else {
                                            console.error("No PDF data available.");
                                            setIsShowDownload(false);
                                            setIsLoader(false);
                                        }
                                    },
                                })
                            );
                        }
                    },
                })
            );
        } catch (error) {
            console.error("Error fetching PDF:", error);
            setIsShowDownload(false);
            setIsLoader(false);
        }
    };

    const getScores = (data) => {
        const scoreMap = {}
        data?.result?.map((item) => {
            item?.performance_results?.map((it) => {
                scoreMap[it?.category_name] = it?.average_score
            })
        })
        setScores(scoreMap)
    }

    const triggerDownload = () => {
        const currentReport = pdfReport;

        setTimeout(async () => {
            try {
                if (downloadRef.current) {
                    const pdfBlob = await downloadRef.current.download();

                    if (pdfBlob) {
                        const formData = new FormData();
                        const pdfFile = new File(
                            [pdfBlob],
                            `Report_${currentReport.currentBacklogId}.pdf`,
                            { type: "application/pdf" }
                        );

                        formData.append("files", pdfFile);
                        await dispatch(
                            multiUpload({
                                files: formData,
                                callBack: async (uploadedFiles) => {
                                    const uploadedUrl = uploadedFiles?.[0]?.url;

                                    if (uploadedUrl) {
                                        await dispatch(
                                            updatePdfURL({
                                                reportId: currentReport.currentBacklogId,
                                                url: uploadedUrl,
                                            })
                                        );
                                    }
                                },
                            })
                        );
                    }

                    setPdfReport(null);
                } else {
                    console.error("Download ref not ready");
                }
            } catch (err) {
                console.error("Download failed", err);
            } finally {
                setIsShowDownload(false);
                setIsLoader(false);
            }
        }, 100);
    };

    useEffect(() => {
        if (pdfReport) {
            triggerDownload();
        }
    }, [pdfReport]);


    const getAnswerText = (list) => {
        return [
            list?.subOption ? `${list?.subOption?.title} :` : "",
            list?.options?.title || "-",
            list?.text_answer || "",
        ].filter(Boolean).join(" ");
    };

    const getGreaseInfo = (list) => {
        return list?.grease_name || list?.grease_size || "";
    };

    return (
        <MainLayout>
            {isLoader ? (
                <div className="loader-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', flexDirection: "column" }}>
                    <Loader />
                    <div style={{ marginTop: "10px" }}>
                        Do not go back or refresh the page while the report is downloading. Please wait.
                    </div>
                </div>) :
                (
                    <div className="p-5">
                        <div className="d-flex align-items-center justify-content-between">
                            <label className="previewTitle">Preview Details</label>
                            {approvalStatus === 2 &&
                                (
                                    <Button
                                        title={showall ? "Preparing Data..." : "Download as PDF"}
                                        buttonStyle={{
                                            width: "auto", height: "48px",
                                            backgroundColor: "#1F2155",
                                            border: "1.5px solid #1F2155",
                                            textAlign: "center",
                                            pointerEvents: "auto",
                                        }}
                                        titleStyle={{ fontSize: "20px" }}
                                        onClick={() => handleDownloadPDF(AssesmentId)}
                                    />
                                )
                            }
                        </div>
                        {/* Accordion */}
                        <div ref={contentRef}>
                            {isloading === "loading" ? (
                                <Skeleton count={5} height={100} style={{ marginTop: "20px" }} />
                            ) : (
                                previewData?.map((item, index) => {
                                    return (
                                        <div className="accordionWrapper my-4">
                                            <div
                                                className="accordionHeader"
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                <div className="accordionTitle">
                                                    {item?.category_name?.category_name} -{" "}
                                                    <span className="subModuleTitle">
                                                        {item?.sub_category_name?.subCategory_name}
                                                    </span>
                                                </div>
                                                <div>
                                                    {openAccordion === index ? (
                                                        <IoIosArrowUp size={20} className="icons" />
                                                    ) : (
                                                        <IoIosArrowDown size={20} className="icons" />
                                                    )}
                                                </div>
                                            </div>
                                            {openAccordion?.includes(index) && (
                                                <div className="accordionContent">
                                                    <div
                                                        className={`subModuleQuestion ${approvalStatus === 2 ? "disabled" : ""}`}
                                                        onClick={() => {
                                                            navigate(`/approval/view-detail/${assessment_id}?category_id=${item?.category_name?.category_id}&sub_category_id=${item?.sub_category_name?.subCategory_id}`, {
                                                                state: {
                                                                    question_id: item?.question_name?.question_id,
                                                                    category_id: item?.category_name?.category_id,
                                                                    sub_category_id: item?.sub_category_name?.subCategory_id,
                                                                    assessment_id: assessment_id,
                                                                }
                                                            });
                                                        }}

                                                    >
                                                        {index + 1}&nbsp;.&nbsp;{item?.question_name?.question}
                                                    </div>
                                                    {item?.answers?.length > 0 ? (
                                                        item?.answers?.map((list, answerIndex) => {
                                                            const lastOccurrenceMap = new Map();
                                                            item?.answers?.forEach((list, index) => {
                                                                lastOccurrenceMap.set(list.user_name, index);
                                                            });
                                                            const isLastOccurrence =
                                                                lastOccurrenceMap.get(list.user_name) === answerIndex;
                                                            return (
                                                                <div>
                                                                    <div className="d-flex align-items-center my-2">
                                                                        {list?.user?.profile_image ? (
                                                                            <img
                                                                                src={list?.user?.profile_image}
                                                                                alt={list?.user_name}
                                                                                className="reviewProfileImage"
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                src={sampleProfile}
                                                                                alt="profile"
                                                                                className="reviewProfileImage"
                                                                            />
                                                                        )}

                                                                        <div className="answeredMemberName mx-4">
                                                                            {list?.user_name}
                                                                        </div>
                                                                        <div className="answeredMemberName">
                                                                            {list?.points}
                                                                        </div>
                                                                    </div>
                                                                    {list?.bearing_size && (
                                                                        <div>{list?.bearing_size}  ({list?.bearing_size === 'small' ? '<55mm' : list?.bearing_size === 'medium' ? '55mm - 200mm' : '>200mm'})</div>)}
                                                                    <div>
                                                                        {getGreaseInfo(list) ? (
                                                                            <>
                                                                                {getAnswerText(list)}
                                                                                <br />
                                                                                {getGreaseInfo(list)}
                                                                            </>
                                                                        ) : (
                                                                            getAnswerText(list)
                                                                        )}
                                                                    </div>
                                                                    {isLastOccurrence && (
                                                                        <>
                                                                            <div className="answeredMemberName my-2">
                                                                                Notes
                                                                            </div>
                                                                            <div>{list?.notes}</div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <div>No Answers</div>
                                                    )}

                                                    <div className="my-3">
                                                        <div className="answeredMemberName">Observation</div>
                                                        <div
                                                            className="my-2 notes-content allText"
                                                            dangerouslySetInnerHTML={{ __html: item?.research_data[0]?.notes ?? "" }}
                                                        ></div>

                                                    </div>
                                                    <div className="mt-3">
                                                        <div className="answeredMemberName">Assessment References</div>
                                                        {item?.research_data?.[0]?.upload?.length > 0 ? (
                                                            item.research_data[0].upload.map((file, index) => {
                                                                let urls = [];

                                                                if (typeof file === "string") {
                                                                    urls = [file];
                                                                } else if (Array.isArray(file.image_url)) {
                                                                    urls = file.image_url;
                                                                } else if (typeof file.image_url === "string") {
                                                                    urls = [file.image_url];
                                                                }

                                                                let isString = typeof file === "string";
                                                                // let fileUrl = isString ? file : file.image_url;
                                                                let fileText = !isString ? file.text : null;

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className="evidence-item my-2"
                                                                        style={{
                                                                            border: "1px solid black",
                                                                            padding: "10px",
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            // maxWidth: "200px",
                                                                        }}
                                                                    >
                                                                        <div className="media-wrap">
                                                                            {urls.map((fileUrl, i) =>
                                                                                fileUrl.endsWith(".pdf") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                                                                        <p style={{ marginBottom: 0 }}>Open PDF</p>
                                                                                    </a>
                                                                                ) : fileUrl.endsWith(".docx") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={DocIcon} alt="Doc" width="75px" height="auto" />
                                                                                        <p style={{ marginBottom: 0 }}>Open Doc</p>
                                                                                    </a>
                                                                                ) : fileUrl.endsWith(".xlsx") ? (
                                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={XlsIcon} alt="Xlsx" width="75px" height="auto" />
                                                                                        <p style={{ marginBottom: 0 }}>Open Xlsx</p>
                                                                                    </a>
                                                                                ) : (
                                                                                    <ImageModal src={fileUrl} alt={`evidence-${index}`} />
                                                                                ))}
                                                                        </div>
                                                                        {fileText && (
                                                                            <div
                                                                                className="notes-content mt-2 remove-bg allText"
                                                                                dangerouslySetInnerHTML={{ __html: fileText }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div>No Assessment References</div>
                                                        )}
                                                    </div>
                                                    <div className="my-3 ">
                                                        <div className="answeredMemberName">Insights</div>
                                                        <div
                                                            className="my-2 notes-content allText"
                                                            dangerouslySetInnerHTML={{ __html: item?.research_data[0]?.insights ?? "" }}
                                                        ></div>
                                                    </div>
                                                    <div>
                                                        <div className="answeredMemberName">Recommendation</div>
                                                        {item?.recommendation_data?.length ? (
                                                            item.recommendation_data.map((rec, index) => {
                                                                if (!rec?.message && !rec?.image_url) return null;
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className="recommendation-item my-2"
                                                                        style={{
                                                                            border: "1px solid black",
                                                                            padding: "10px",
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            // maxWidth: "200px",
                                                                        }}
                                                                    >
                                                                        {/* {rec?.image_url && (
                                                                            <ImageModal src={rec.image_url} alt={`recommendation-${index}`} />
                                                                        )} */}
                                                                        <div className="media-wrap">
                                                                            {Array.isArray(rec.image_url) &&
                                                                                rec.image_url.map((fileUrl, i) => {
                                                                                    const lower = fileUrl.toLowerCase();

                                                                                    if (lower.endsWith(".pdf")) {
                                                                                        return (
                                                                                            <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={PDFIcom} width="75px" alt="PDF" />
                                                                                                <p style={{ marginBottom: 0 }}>Open PDF</p>
                                                                                            </a>
                                                                                        );
                                                                                    }

                                                                                    if (lower.endsWith(".docx")) {
                                                                                        return (
                                                                                            <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={DocIcon} width="75px" alt="Doc" />
                                                                                                <p style={{ marginBottom: 0 }}>Open Doc</p>
                                                                                            </a>
                                                                                        );
                                                                                    }

                                                                                    if (lower.endsWith(".xlsx")) {
                                                                                        return (
                                                                                            <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={XlsIcon} width="75px" alt="Xlsx" />
                                                                                                <p style={{ marginBottom: 0 }}>Open Xlsx</p>
                                                                                            </a>
                                                                                        );
                                                                                    }

                                                                                    // IMAGE
                                                                                    return <ImageModal key={i} src={fileUrl} alt={`recommendation-${i}`} />;
                                                                                })}
                                                                        </div>

                                                                        {rec?.message && (
                                                                            <div
                                                                                className="notes-content mt-2 allText"
                                                                                dangerouslySetInnerHTML={{ __html: rec.message }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div>No Recommendations</div>
                                                        )}
                                                    </div>
                                                    <div className="my-3">
                                                        <div className="answeredMemberName">Final Score</div>
                                                        <div>{item?.research_data[0]?.final_score ?? ""}</div>
                                                    </div>
                                                    {/* <div className="my-3">
                                                        <div className="answeredMemberName">Approver feedback</div>
                                                        <div
                                                            className="my-2 notes-content allText"
                                                            dangerouslySetInnerHTML={{ __html: item?.research_data[0]?.approver_feedback ?? "" }}
                                                        ></div>
                                                    </div> */}
                                                    <div className="my-3">
                                                        <div className="answeredMemberName">Approver Feedback</div>

                                                        {(item?.research_data[0]?.approver_feedback?.trim() ||
                                                            item?.research_data[0]?.approver_feedback_upload?.length > 0) ? (

                                                            <div
                                                                className="recommendation-item my-2"
                                                                style={{
                                                                    border: "1px solid black",
                                                                    padding: "10px",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <div className="media-wrap">
                                                                    {item?.research_data[0]?.approver_feedback_upload?.map((fileUrl, i) => {
                                                                        const lower = fileUrl.toLowerCase();

                                                                        if (lower.endsWith(".pdf")) {
                                                                            return (
                                                                                <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                    <img src={PDFIcom} width="75px" alt="PDF" />
                                                                                    <p style={{ marginBottom: 0 }}>Open PDF</p>
                                                                                </a>
                                                                            );
                                                                        }

                                                                        if (lower.endsWith(".docx")) {
                                                                            return (
                                                                                <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                    <img src={DocIcon} width="75px" alt="Doc" />
                                                                                    <p style={{ marginBottom: 0 }}>Open Doc</p>
                                                                                </a>
                                                                            );
                                                                        }

                                                                        if (lower.endsWith(".xlsx")) {
                                                                            return (
                                                                                <a key={i} href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                    <img src={XlsIcon} width="75px" alt="Xlsx" />
                                                                                    <p style={{ marginBottom: 0 }}>Open Xlsx</p>
                                                                                </a>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <ImageModal
                                                                                key={i}
                                                                                src={fileUrl}
                                                                                alt={`approver-feedback-${i}`}
                                                                            />
                                                                        );
                                                                    })}
                                                                </div>

                                                                {item?.research_data[0]?.approver_feedback && (
                                                                    <div
                                                                        className="notes-content mt-2 allText"
                                                                        dangerouslySetInnerHTML={{ __html: item?.research_data[0]?.approver_feedback }}
                                                                    />
                                                                )}
                                                            </div>

                                                        ) : (
                                                            <div>No Approver Feedback</div>
                                                        )}
                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            )}

                            <div className="accordionWrapper mb-4">
                                <div
                                    className="accordionHeader"
                                    onClick={() => toggleSpareAccordion(0)}
                                >
                                    <div className="accordionTitle">KG Product Offerings</div>
                                    <div>
                                        {openAccordionSpare === 0 ? (
                                            <IoIosArrowUp size={20} className="icons" />
                                        ) : (
                                            <IoIosArrowDown size={20} className="icons" />
                                        )}
                                    </div>
                                </div>
                                {Array.isArray(sparePartsLogData) && sparePartsLogData?.map((sparePart, index) => (
                                    openAccordionSpare === 0 && (
                                        <div key={index} className="accordionContent" style={{ border: "1px solid #1f2155", borderRadius: "4px", marginBottom: "8px" }}>
                                            <div className="my-3">
                                                <div className="answeredMemberName">Module name</div>
                                                <div>{sparePart?.module_name}</div>
                                            </div>
                                            <div className="my-3">
                                                <div className="answeredMemberName">Product Name</div>
                                                <div>{sparePart?.product_name}</div>
                                            </div>
                                            <div className="my-3">
                                                <div className="answeredMemberName">Recommendations</div>
                                                <div>{sparePart?.recommendations}</div>
                                            </div>
                                            <div className="my-3">
                                                <div className="answeredMemberName">Priority</div>
                                                <div>{sparePart?.priority}</div>
                                            </div>
                                            <div>
                                                <div className="answeredMemberName">Photos</div>
                                                <div className="d-flex flex-wrap align-items-center my-2">
                                                    {sparePart?.photos.length > 0 ? (
                                                        <>
                                                            {sparePart?.photos?.map((item, photoIndex) => {
                                                                const isPDF = item.toLowerCase().endsWith(".pdf");
                                                                return (
                                                                    <div key={photoIndex}>
                                                                        {isPDF ? (
                                                                            <div className="pdf-container">
                                                                                <div className="individual-pdf-container" style={{ paddingRight: "10px" }}>
                                                                                    <a href={item} target="_blank" rel="noopener noreferrer">
                                                                                        <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                                                                        <p>Open PDF</p>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <ImageModal src={item} alt={`evidence-${photoIndex}`} />
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </>
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                            <div className="accordionWrapper mb-4">
                                <div
                                    className="accordionHeader"
                                    onClick={() => setOpenAccordionUploadedSpare(openAccordionUploadedSpare === 0 ? null : 0)}
                                >
                                    {/* <div className="accordionTitle">Uploaded Spare Parts</div> */}
                                    <div className="accordionTitle">Uploaded Product Mapping</div>
                                    <div>
                                        {openAccordionUploadedSpare === 0 ? (
                                            <IoIosArrowUp size={20} className="icons" />
                                        ) : (
                                            <IoIosArrowDown size={20} className="icons" />
                                        )}
                                    </div>
                                </div>
                                {openAccordionUploadedSpare === 0 && (
                                    <div>
                                        {uploadedSpareParts.length === 0 ? (
                                            <div className="accordionContent">No Uploaded Product Mapping found.</div>
                                            // <div className="accordionContent">No uploaded spare parts found.</div>
                                        ) : (
                                            uploadedSpareParts.map((spare, idx) => (
                                                <div key={spare.log_id} className="accordionContent" style={{ border: "1px solid #1f2155", borderRadius: "4px", marginBottom: "8px" }}>
                                                    <div className="my-3">
                                                        <div className="answeredMemberName">Product Name</div>
                                                        <div>{spare.product_name}</div>
                                                    </div>
                                                    <div className="my-3">
                                                        <div className="answeredMemberName">Photos</div>
                                                        <div className="d-flex flex-wrap align-items-center my-2">
                                                            {spare.photos && spare.photos.length > 0 ? (
                                                                spare.photos.map((photo, photoIdx) => (
                                                                    <div key={photoIdx} style={{ marginRight: "10px" }}>
                                                                        <ImageModal src={photo.url} alt={photo.name} />
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div>No images</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

            {reviewed ? (
                " "
            ) : (
                <div className="previewButtonContainer">
                    <Button
                        title={"Send for rework"}
                        titleStyle={rejectTitle}
                        buttonStyle={rejectButton}
                        onClick={onReject}
                    />
                    <Button
                        title={"Approve"}
                        titleStyle={approveTitle}
                        buttonStyle={approveButton}
                        forForm={true}
                        onClick={handleApprove}
                    />
                </div>
            )}
            {
                isShowDownload &&
                <ReportDownload ref={downloadRef} resultData={pdfReport} scores={scores} />
            }
            <Modal
                open={rejectModal}
                closeModal={() => {
                    setRejectModal(false);
                }}
            >
                <div className="closeModalContainer_Contact">
                    <InputBox
                        type="textarea"
                        label={"Reason for Rework"}
                        inputStyle={{
                            height: "200px",
                        }}
                        labelStyle={noteLabel}
                        value={rejectionReason}
                        onChange={(e) => {
                            setRejectionReason(e?.target?.value);
                            if (errorReasonMessage) {
                                setErrorReasonMessage("");
                            }
                        }}
                    />
                    {errorReasonMessage && (
                        <p
                            style={{
                                color: "red",
                                fontSize: "14px",
                                marginBottom: "10px",
                                fontFamily: "inter",
                            }}
                        >
                            {errorReasonMessage}
                        </p>
                    )}

                    <div>
                        <Button
                            onClick={() => {
                                if (rejectionReason?.trim() === "") {
                                    setErrorReasonMessage(
                                        "Please enter a reason before submitting."
                                    );
                                    return;
                                } else {
                                    const body = {
                                        approval_status: 3,
                                        assessor_id: assessor_id,
                                        rejection_reason: rejectionReason,
                                    };
                                    dispatch(
                                        addApproveReject({
                                            assessment_id: assessment_id,
                                            body: body,
                                            callBack: navigate("/"),
                                        })
                                    );
                                    setRejectModal(false);
                                    setRejectionReason("");
                                    setErrorReasonMessage("");
                                }
                            }}
                            buttonStyle={{
                                height: "44px",
                                width: "150px",
                                float: "right",
                                marginTop: "15px",
                            }}
                            titleStyle={{ fontSize: "16px", }}
                            title="Submit"
                        />
                    </div>
                </div>
            </Modal>
        </MainLayout>
    );
};

export default ApprovalPreview;
